<ion-content class="ion-padding">

  <div class="modalBack" >
    <ion-button  (click)="goBack()" fill="clear">
      <ion-label> 
        <img src="assets/imgs/Icon-akar-arrow-left.svg" alt="Veggly Logo">
      </ion-label>
    </ion-button>
  </div>

  <div id="pageContent">
    
    <div id="headerContainer">

      <div class="imgDiv">
        <img src="assets/imgs/logo_novo.svg" alt="Veggly Logo">
      </div>
    
      <div class="welcome"> 
        {{'resetPassword' | translate}}
      </div>
    </div>

    <div class="formSection">
      <ion-list style="margin-bottom: 0px; padding: bottom 0px;">
        <div class="fillyourdetails">
          {{'pleaseResetYourPassword' | translate}}
        </div>
        <form [formGroup]="myForm" class="myFormStyle" >
          

          <ion-item lines="none"  class="custom" [class.invalid]="!myForm.get('userpassControl')?.valid && (myForm.get('userpassControl')?.dirty || submitAttempt)">
            <ion-icon  slot="start" name="lock-closed"></ion-icon>
            <ion-input [type]="show ? 'text' : 'password'"  class="custom" placeholder="{{'password' | translate}}" type="password" formControlName="userpassControl"
            ></ion-input>
            <ion-icon (click)="password()" slot="end" [name]="show ? 'eye' : 'eye-off-outline'"   aria-hidden="true"></ion-icon>
          </ion-item>
  
          <ion-item class="alert" *ngIf="!myForm.get('userpassControl')?.valid && (myForm.get('userpassControl')?.dirty || submitAttempt)">
            <p >
              {{'validPasswordMsg' | translate}}
            </p>
          </ion-item>
  
          <ion-item lines="none"  class="custom" [class.invalid]="!myForm.get('reenterpassControl')?.valid && (myForm.get('reenterpassControl')?.dirty || submitAttempt)">
            <ion-icon  slot="start" name="lock-closed"></ion-icon>
            <ion-input [type]="show ? 'text' : 'password'"  class="custom" placeholder="{{'reenterPassword' | translate}}" type="password" formControlName="reenterpassControl"
            ></ion-input>
            <ion-icon (click)="password()" slot="end" [name]="show ? 'eye' : 'eye-off-outline'"   aria-hidden="true"></ion-icon>
          </ion-item>
  
          <ion-item class="alert" *ngIf="!myForm.get('reenterpassControl')?.valid && (myForm.get('reenterpassControl')?.dirty || submitAttempt)">
            <p >
              {{'reenterValidPassword' | translate}}
            </p>
          </ion-item>
        </form>
      </ion-list>
    </div>

    <div class="bottomButtons">
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-button (click)="resetPass()" class="buttonShadow" expand="full" color="primary"  shape="round" fill="solid" >{{'save' | translate}}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</ion-content>
